import { FC } from 'react';

import saveIcon from 'common/assets/svg/actions/save.svg';

import Button from './Button';

type SaveButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

const SaveButton: FC<SaveButtonProps> = ({ onClick, disabled }) => {
  return (
    <Button
      src={saveIcon}
      label="Save"
      backgroundColor="primary"
      hoverBackgroundColor="canyon-iris"
      color="white"
      iconSize={11}
      onClick={onClick}
      disabled={disabled}
    />
  );
};

export default SaveButton;
